import React from 'react';

/**
 * WheelsCards - Card view component for Wheels page
 * Displays wheels in a card grid format
 */
const WheelsCards = ({
  wheels,
  onViewWheel,
  onEditWheel,
  formatDate
}) => {
  return (
    <div className="wheels-cards-container">
      {wheels.map((wheel) => (
        <div key={wheel.id} className="wheel-card">
          <div className="card-header">
            <div className="card-header-left">
              <span className="card-wheel-number clickable-link" onClick={() => onViewWheel(wheel)}>
                {wheel.wheel_number}
              </span>
            </div>
            <div className="card-header-right">
              {wheel.is_full && (
                <span className="full-badge">FULL</span>
              )}
              {wheel.label_text && (
                <span className={`wheel-label-badge ${wheel.label_color || 'gray'}`}>
                  {wheel.label_text}
                </span>
              )}
            </div>
          </div>
          <div className="card-body">
            {wheel.customer_name && (
              <div className="card-customer">
                <span className="customer-label">Customer:</span>
                <span className="customer-value">{wheel.customer_name}</span>
              </div>
            )}
            <div className="card-lot-info">
              <span className="lot-label">Lot:</span>
              <span className="lot-value">{wheel.all_lot_numbers || wheel.lot_number}</span>
            </div>
            {wheel.item_names && (
              <div className="card-items-preview">
                <span className="items-preview">{wheel.item_names}</span>
              </div>
            )}
            <div className="card-details">
              <div className="card-detail-item">
                <span className="detail-label">Items:</span>
                <span className="detail-value">{wheel.item_count} items</span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Weight:</span>
                <span className="detail-value">{parseFloat(wheel.total_weight || 0).toFixed(2)} kg</span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Created:</span>
                <span className="detail-value">{formatDate(wheel.created_at)}</span>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button
              className="card-action-btn view"
              onClick={() => onViewWheel(wheel)}
            >
              View
            </button>
            <button
              className="card-action-btn edit"
              onClick={() => onEditWheel(wheel)}
            >
              Edit
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WheelsCards;
